import * as React from 'react';
import DescriptionPage from '../components/HeadlineSubHeadlineText';
import Div from '../components/Div.styled';
import useMediaQuery from '../hooks/useMediaQuery';
import {Image, LazyPicture} from '@volkswagen-onehub/components-core';
import {JSONMARKDOWN, VWCARMODELLABELS} from '../types/results';
import {VWCarModel} from '../types/surveyResponse';
import {AnalyticEvent, sendAnalyticPayload} from '../utils/analytic';

export interface IBannerProps {
  image: string;
  title: string;
  titleStrong: string;
  descriptions: string;
  handleCTA: () => void;
  subTitle: string;
  CTAButtonTitle: string;
  CTAButtonPrimaryTitle: string;
  handleCTAPrimary: () => void;
}

export interface IResultSectionFiveProps {
  model: VWCarModel;
  assetUrl: string;
  image: string;
  hero_sub_title: string;
  hero_title_line_1: string;
  body: string;
  image_bg: string;
  cta_one: string;
  cta_one_src: string;
  cta_two: string;
  cta_two_src: string;
  isAmarok: boolean;
}

export default function ResultSectionFive({
  model,
  assetUrl,
  image_bg,
  image,
  hero_sub_title,
  hero_title_line_1,
  body,
  cta_one,
  cta_one_src,
  cta_two,
  cta_two_src,
}: IResultSectionFiveProps) {
  const {isMobile} = useMediaQuery();

  function onClickCta(type: 'primary' | 'secondary') {
    const cta_src = type === 'primary' ? cta_one_src : cta_two_src;
    const cta_text = type === 'primary' ? cta_one : cta_two;

    window.open(cta_src, '_blank');
    sendAnalyticPayload(
      {
        process: {
          StepName: cta_text,
          StepNumber: '',
        },
        link: {
          name: cta_text,
        },
      },
      AnalyticEvent.CTAClick,
    );
  }

  return (
    <Div>
      <Div
        // assetUrl + image
        customStyles={{
          position: 'relative',
          backgroundImage: `url(${assetUrl + image_bg})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          textAlign: 'center',
          transformOrigin: 'center bottom',
          height: isMobile ? '392px' : '643px',
        }}
      />
      <Div
        customStyles={{
          display: 'flex',
          justifyContent: 'center',
          position: 'absolute',
          width: '100%',
          left: '50%',
          transform: 'translateY(-100%) translateX(-50%)',
          margin: '0 auto',
        }}
      >
        <LazyPicture>
          <source srcSet={assetUrl + image} media="(min-width: 1440px)" />
          <Image
            src={assetUrl + image}
            width={'100%'}
            height={'auto'}
            alt="Car Model Text"
            key={'car-model-text'}
          />
        </LazyPicture>
      </Div>
      <Div margin="40px 0 0">
        <DescriptionPage
          subTitle="Get notified"
          title={hero_sub_title}
          titleStrong={hero_title_line_1}
          descriptions={body
            .replace(JSONMARKDOWN.model, VWCARMODELLABELS[model])
            .replace('&', 'or')}
          CTAButtonTitle={cta_two}
          handleCTA={() => onClickCta('secondary')}
          CTAButtonPrimaryTitle={cta_one}
          handleCTAPrimary={() => onClickCta('primary')}
        />
      </Div>
    </Div>
  );
}
